module.exports = "<nav-bar>\n  <ui-view></ui-view>\n</nav-bar>\n"